<template>
    <div id="page-account-settings">
        <!-- right content section -->
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <!-- social header -->
                        <div class="col-12">
                            <div class="d-flex align-items-center mb-2">
                                <h1 class="mb-0 ml-75 mx-auto">Creditfixrr Affiliate Program</h1>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <a href="https://affiliates.creditfixrr.com/signup" target="_blank" class="btn btn btn-outline-primary mr-2"> Sign Up Now!</a>
                        <a type="button" class="btn btn-primary waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#referAndEarn"> Refer & Earn </a>
                    </div>
                    <!-- divider -->
                    <div class="col-12">
                        <hr class="my-2" />
                    </div>

                    <div class="col-12 mt-1">
                          <!-- pricing faq -->
                          <div class="pricing-faq">
                              <h2 class="text-center">Common Questions</h2>
                              <h4 class="text-center text-primary"> Get paid. Refer a friend to Creditfixrr and you’ll earn 25% when they complete their first successful Creditfixrr membership payment.* </h4>
                              <div class="row my-2">
                                  <div class="col-12 col-lg-10 col-lg-offset-2 mx-auto">
                                      <!-- faq collapse -->
                                      <div class="collapse-margin collapse-icon" id="accordionExample">
                                          <div class="card">
                                              <div class="card-header" id="headingOne" data-toggle="collapse"
                                                  role="button" data-target="#collapseOne" aria-expanded="false"
                                                  aria-controls="collapseOne">
                                                  <span class="lead collapse-title">Who is eligible for the Creditfixrr referral program?</span>
                                              </div>

                                              <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      All Creditfixrr members and account holders are eligible for the referral program. Simply log
                                                      in to your affiliate dashboard to find your unique referral link.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingThree" data-toggle="collapse"
                                                  role="button" data-target="#collapseThree" aria-expanded="false"
                                                  aria-controls="collapseThree">
                                                  <span class="lead collapse-title">Do I need to have a Creditfixrr membership to get a unique referral code?</span>
                                              </div>
                                              <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      No. However, while you do not need to have a Creditfixrr
                                                      membership to refer friends, you do need to be a Creditfixrr account. There
                                                      is no cost to joining Creditfixrr, and you’ll receive access to a couple free
                                                      dispute letters at no cost. Get started today.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingTwo" data-toggle="collapse"
                                                  role="button" data-target="#collapseTwo" aria-expanded="false"
                                                  aria-controls="collapseTwo">
                                                  <span class="lead collapse-title">Does my referral have to sign up for Creditfixrr?</span>
                                              </div>
                                              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      Yes. While we welcome all new Creditfixrr members, your referral must
                                                      sign up for a Creditfixrr account and make at least one
                                                      successful payment before you can receive the 25% reward.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingTwo" data-toggle="collapse"
                                                  role="button" data-target="#collapseTwo" aria-expanded="false"
                                                  aria-controls="collapseTwo">
                                                  <span class="lead collapse-title">Who can I refer to Creditfixrr?</span>
                                              </div>
                                              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      You can refer any individual who meets the minimum requirements:
                                                      Individual must be a U.S. Citizen or permanent resident
                                                      and at least 18 years old. Valid bank account and Social Security
                                                      Number are required. Subject to ID Verification. You may refer
                                                      friends, family members, coworkers, or acquaintances. However, you
                                                      will only earn 10% for every referral who has successfully created
                                                      a credit
                                                      fixrr account and made a successful payment.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingTwo" data-toggle="collapse"
                                                  role="button" data-target="#collapseTwo" aria-expanded="false"
                                                  aria-controls="collapseTwo">
                                                  <span class="lead collapse-title">How do I ensure my friend’s application is linked to my referral account?</span>
                                              </div>
                                              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      Share your unique invite link and make sure your referral signs up
                                                      directly from that URL. Please note that if your referral does not
                                                      sign up using your referral link, you will not be credited and
                                                      therefore ineligible for the 10% reward.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingTwo" data-toggle="collapse"
                                                  role="button" data-target="#collapseTwo" aria-expanded="false"
                                                  aria-controls="collapseTwo">
                                                  <span class="lead collapse-title">How do I get paid💰?</span>
                                              </div>
                                              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      Your referral reward will be distributed from Creditfixrr by
                                                      check. Creditfixrr
                                                      will notify you when your referrals first payment has been
                                                      completed and issue a check in the amount of 10%. Please allow for
                                                      30 business days for your payment to arrive.
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="card">
                                              <div class="card-header" id="headingTwo" data-toggle="collapse"
                                                  role="button" data-target="#collapseTwo" aria-expanded="false"
                                                  aria-controls="collapseTwo">
                                                  <span class="lead collapse-title">When do I get paid 💰?</span>
                                              </div>
                                              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                  data-parent="#accordionExample">
                                                  <div class="card-body">
                                                      Your referral reward will be paid via PayPal to you once your referral’s
                                                      first payment has been completed. Payments may take up to 30 days
                                                      to process. Once the payment has been completed, you will receive
                                                      notification or you cvan check your Affiliate Dashboard and will receive a payment via PayPal in 30 business
                                                      days.
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <!--/ pricing faq -->
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="referAndEarn" tabindex="-1" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-edit-user modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal('#referAndEarn')" style="border: 0px;">
                            <span aria-hidden="true">X</span>
                        </button>
                    </div>
                    <div class="modal-body pb-5 px-sm-4 pt-50">
                        <div class="text-center mb-4">
                        <h1 class="mb-2">Refer &amp; Earn</h1>
                        <p class="text-center mb-5 w-75 m-auto text-primary">Invite your friend to Creditfixrr. If they sign up, you will receive 25% of their first subscription.</p>
                        </div>
                        <div class="row mb-4">
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-4">
                                <div class="modal-refer-and-earn-step bg-label-primary">
                                    <vue-feather type="mail" size="48"></vue-feather>
                                </div>
                                </div>
                                <div class="text-center">
                                <h4>Send Invitation 🤟🏻</h4>
                                <p class="mb-lg-0 text-primary">Send your referral link to your friend</p>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-4">
                                <div class="modal-refer-and-earn-step bg-label-primary">
                                    <vue-feather type="list" size="48"></vue-feather>
                                </div>
                                </div>
                                <div class="text-center">
                                <h4>Registration 👩🏻&zwj;💻</h4>
                                <p class="mb-lg-0 text-primary">Let them register to our services</p>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-4">
                                <div class="modal-refer-and-earn-step bg-label-primary">
                                    <vue-feather type="dollar-sign" size="48"></vue-feather>
                                    <i class="ti ti-gift"></i>
                                </div>
                                </div>
                                <div class="text-center">
                                <h4>Free Trial 🎉</h4>
                                <p class="mb-0 text-primary">Earn 25% when they sign up via your link.</p>
                                </div>
                            </div>
                        </div>

                    <div class="row mb-4">
                        <div class="col-lg-6">
                            <h4>Invite your friends</h4>
                            <form class="row g-3" onsubmit="return false">
                                <div class="col-lg-10">
                                    <p class="form-label text-primary" for="modalRnFEmail">Enter your friend’s email address and invite them to join Creditfixrr</p>
                                    <input type="text" id="modalRnFEmail" class="form-control" placeholder="Enter a comma after each email i.e. example@domain.com, example2@domain.com" aria-label="example@domain.com" v-model="emailList">
                                <div data-lastpass-icon-root="true" style="position: relative !important; height: 0px !important; width: 0px !important; float: left !important;"></div></div>
                                <div class="col-lg-2 d-flex align-items-end">
                                    <button type="button" class="btn btn-primary waves-effect waves-light" @click="submitEmails">Send</button>
                                </div>
                            </form>
                        </div>
                        <div class="col-lg-6">
                            <h4 class="">Share the referral link</h4>
                            <form class="row g-3" onsubmit="return false">
                                <div class="col-lg-8">
                                    <p class="form-label text-primary" for="modalRnFLink">You can also copy and send it or share it on your social media.</p>
                                    <div class="input-group input-group-merge">
                                    <input type="text" id="modalRnFLink" class="form-control" v-model="userStore.user.affiliate_link" @change="autoSaveAffiliateLink" placeholder="Paste Your Affiliate Referral Link Here." ref="affiliate_link">
                                    <span class="input-group-text text-primary cursor-pointer copy-affiliate-link" id="basic-addon33" @click="copyAffiliateLink">Copy link</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 d-flex align-items-end">
                                    <div class="btn-social">
                                        <button type="button" class="btn btn-icon btn-facebook mr-2 waves-effect waves-light" @click="socialShare('facebook')">
                                            <vue-feather type="facebook" style="height:17px;width:13px;"></vue-feather>
                                        </button>
                                        <button type="button" class="btn btn-icon btn-twitter mr-2 waves-effect waves-light" @click="socialShare('twitter')">
                                            <vue-feather type="twitter" style="height:17px;width:13px;"></vue-feather>
                                        </button>
                                        <button type="button" class="btn btn-icon btn-twitter mr-2 waves-effect waves-light" @click="socialShare('linkedin')">
                                            <vue-feather type="linkedin" style="height:17px;width:13px;"></vue-feather>
                                        </button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                        <hr class="my-5 " style="border-color: #4b9a5e;">
                        <div class="row mt-2" v-if="Object.keys(userStore.affiliate_info).length">
                            <!--  -->
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-2">
                                <div class="modal-refer-and-earn-step bg-label-primary tbl-font-bold">
                                    {{userStore.affiliate_info.visitors }}
                                </div>
                                </div>
                                <div class="text-center">
                                    <h2>Visitors</h2>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-2">
                                <div class="modal-refer-and-earn-step bg-label-primary tbl-font-bold">
                                    {{userStore.affiliate_info.leads}}
                                </div>
                                </div>
                                <div class="text-center">
                                    <h2>Leads</h2>
                                </div>
                            </div>
                            <div class="col-12 col-lg-4 px-4">
                                <div class="d-flex justify-content-center mb-2">
                                <div class="modal-refer-and-earn-step bg-label-primary tbl-font-bold">
                                    {{userStore.affiliate_info.conversions}}
                                </div>
                                </div>
                                <div class="text-center">
                                    <h2>Conversions</h2>
                                </div>
                            </div>
                            <!--  -->
                        </div>
                        <h4 class="fw-bolder mt-4 mb-2">Invited Referrals</h4>
                            <vue-good-table
                            mode="remote"
                                v-on:page-change="onPageChange"
                                v-on:per-page-change="onPerPageChange"
                                v-on:selected-rows-change="selectedOptions"
                                v-on:search="onSearch"
                                :totalRows="totalRecords"
                                :isLoading.sync="isLoading"
                                :pagination-options="{
                                    enabled: true,
                                    perPageDropdown: [5,10, 20, 30, 40, 50, 100],
                                    dropdownAllowAll: false,
                                }"
                                :rows="rows"
                                :columns="columns"
                                :sort-options="{
                                    enabled: false
                                }"
                                :select-options="{ enabled: true,selectOnCheckboxOnly: true,}"
                                styleClass="vgt-table striped"
                                ref="invited_members"
                            >
                            <template #table-row="props">
                                <span v-if="props.column.field == 'name'" class="tbl-font-sm">
                                    {{props.row.name}}
                                </span>
                                <span v-if="props.column.field == 'email'" class="tbl-font-sm">
                                    {{props.row.email}}
                                </span>
                                <span v-if="props.column.field == 'conversion_status'">
                                    <div class="badge badge-primary tbl-font-sm" v-if="props.row.conversion_status == 'conversion'">
                                        {{ props.row.conversion_status }}
                                    </div>
                                    <div class="badge badge-success tbl-font-sm" v-else-if="props.row.conversion_status == 'lead'">
                                        {{ props.row.conversion_status }}
                                    </div>
                                    <div class="badge badge-warning tbl-font-sm" v-else>
                                        {{ props.row.conversion_status }}
                                    </div>
                                </span>
                                <span v-if="props.column.field == 'created_at'" class="tbl-font-sm">
                                    {{props.row.created_at ? formatDate(props.row.created_at,'LL'):''}}
                                </span>
                                <span v-if="props.column.field == 'became_lead_at'" class="tbl-font-sm" >
                                    {{props.row.became_lead_at ? formatDate(props.row.became_lead_at,'LL'):''}}
                                </span>
                                <span v-if="props.column.field == 'became_conversion_at'" class="tbl-font-sm">
                                    {{props.row.became_conversion_at ? formatDate(props.row.became_conversion_at,'LL'):''}}
                                </span>
                                <span v-if="props.column.field == 'action'">
                                    <div class="d-flex">
                                        <div class=" mr-1">
                                            <a href="#" class="item" @click="resendInvite(props.row.id)" v-if="props.row.conversion_status !== 'conversion' || props.row.conversion_status !== 'lead'">
                                                <vue-feather type="send" style="height: 16px;width: 16px;"></vue-feather>
                                            </a>
                                            <a href="#" class="item" @click="deleteInvite(props.row.id)">
                                                <vue-feather type="trash" style="height: 16px;width: 16px;"></vue-feather>
                                            </a>
                                        </div>
                                    </div>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { closeModel} from '../../utilities/_helpers.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import { ref } from 'vue'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import { formatDate } from '../../utilities/_helpers'
export default {
    name: 'ReferralsComponent',
    components:{
        VueGoodTable,
    },
    setup() {
        return {
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            emailList:ref(),
            formatDate:formatDate
        }
    },
    data(){
        const route = this.$router.resolve(
            {
                name: 'referral_list',
                query: { page: '1' },
            }
        );
        return{
            isLoading: true,
            columns: [
            {
                label: 'Name',
                field: 'name',
                type: 'string',
            },
            {
                label: 'Email',
                field: 'email',
                type: 'string',
            },
            {
                label: 'Conversion Status',
                field: 'conversion_status',
                type: 'string',
            },
            {
                label: 'Date Created',
                field: 'created_at',
                type: 'string',
            },
            {
                label: 'Became Lead At',
                field: 'became_lead_at',
                type: 'string',
            },
            {
                label: 'Became Conversion At',
                field: 'became_conversion_at',
                type: 'string',
            },
            {
                label: 'ACTIONS',
                field: 'action',
            }
            ],
            rows: [],
            totalRecords: 0,
            limit:5,
            page:0,
            currentPage: route.href,
        }
    },
    watch: {
        'userStore.user'(value){
            this.getAffiliateStats();
        }
    },
    mounted() {

        if(!_.isEmpty(this.userStore.user)){
            this.getAffiliateStats();
        }
        this.getReferrals(this.currentPage,null);
    },
    methods:{
        getReferrals(uri,page){
            this.page++;
            let $this = this,url;
            url = uri + '&limit='+this.limit
            this.datesent = [];
            axios.post(url).then(function(response) {
                $this.referrals = response.data;
                $this.rows = $this.referrals.data.data.data;
                $this.totalRecords = $this.referrals.data.totalrecord;
                $this.isLoading = false;
            }).catch(function(error) {
                $this.rows = [];
                $this.totalRecords = 0;
            });
        },
        onPageChange(params) {
            let global_data = this.referrals.data.data;
            if (params.prevPage < params.currentPage) { // Next
                this.currentPage = global_data.next_page_url;
                this.getReferrals(global_data.next_page_url, true);
            }
            else { // Previous
                this.currentPage = global_data.prev_page_url;
                this.getReferrals(global_data.prev_page_url, true);
            }
        },
        onPerPageChange(params) {
            let global_data = this.referrals.data.data;
            let links = global_data.links,activeLink;
            links.forEach(element => {
                if(element.active == true){
                    activeLink =element.url
                }else{
                    const route = this.$router.resolve(
                        {
                            name:"referral_list",
                            query: {
                                page: '1',
                            },
                        }
                    );
                    activeLink = route.href;
                }
            });
            this.limit = params.currentPerPage
            this.getReferrals(activeLink, true);
        },
        getAffiliateStats(){
            let affiliate_stats = this.$router.resolve({
                name: 'affiliate_stats'
            });
            axios.post(affiliate_stats.href, { email : this.userStore.user.email })
            .then(({data}) => {
                if(data.error == true) {
                    toastr.error(data.message, 'Error!');
                    return;
                }
                this.userStore.affiliate_info = data.data
            })
            .catch(error => {

            });
        },
        autoSaveAffiliateLink(){
            let refer_user_url = this.$router.resolve({
                name: 'save_affiliate_link'
            });
            axios.post(refer_user_url.href, { affiliate_link : this.userStore.user.affiliate_link })
            .then(({data}) => {
                if(data.error == true) {
                    toastr.error(data.message, 'Error!');
                    return;
                }

                toastr.success(data.message, 'Success!');
            })
            .catch(error => {

            });
        },
        submitEmails() {
            const emails = this.emailList.split(',').map(email => email.trim()).filter(email => email !== '');
            let refer_user_url = this.$router.resolve({
                name: 'refer_user'
            });
            if(emails.length > 0 && emails.length <= 10){
                axios.post(refer_user_url.href, { emails })
                .then(({data}) => {
                    if(data.error == true) {
                        toastr.error(data.message, 'Error!');
                        return;
                    }
                    toastr.success(data.message, 'Success!');
                    this.getReferrals(this.currentPage,null);
                    this.emailList = "";
                    return;
                })
                .catch(error => {

                });
            }else{
                toastr.error("The maximum number of email invites you can send per round is limited to 10.", 'Error!');
            }

        },
        resendInvite(id){
            let refer_user_url = this.$router.resolve({
                name: 'referral_resend'

            });
            axios.post(refer_user_url.href, { referral:id })
            .then(({data}) => {
                if(data.error == true) {
                    toastr.error(data.message, 'Error!');
                    return;
                }
                toastr.success(data.message, 'Success!');
            })
            .catch(error => {

            });
        },
        deleteInvite(id){
            let $this = this;
            let refer_user_url = this.$router.resolve({
                name: 'referral_delete'
            });
            Swal.fire({
                title: $this.localizationStore.translate('are.you.sure'),
                text: 'You will not be able to revert this process.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Remove Invite',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    axios.post(refer_user_url.href, { referral:id })
                    .then(({data}) => {
                        if(data.error == true) {
                            swal.close();
                            toastr.error(data.message, 'Error!');
                            return;
                        }
                        swal.close();
                        toastr.success(data.message, 'Success!');
                        $this.getReferrals($this.currentPage,null)
                        return;
                    })
                    .catch(error => {
                        swal.close();
                    });
                }
            })

        },
        copyAffiliateLink(){
            this.$refs.affiliate_link.select()
            document.execCommand('copy');
            toastr.success('Affliate linke copied!','copied');
            this.tooltipData = "Copied!"
        },
        socialShare(type) {
            let params = {
                url: this.userStore.user.affiliate_link,
                type: type,
            };
            let refer_user_url = this.$router.resolve({
                name: 'socialshare'
            });
            axios.post(refer_user_url.href, params)
            .then(({data}) => {
                if(data.error == true) {
                    toastr.error(data.message, 'Error!');
                    return;
                }
                window.open(data.shareUrl, "_blank");
            })
            .catch(error => {
            });
        },
    }
}

</script>
<style>

.tbl-font-sm{
    font-size: 0.8em;
}
.tbl-font-bold{
    font-size: 2em;
    font-weight: 600;
}
.copy-affiliate-link{
    border-left: 0px !important;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    color: white !important;
    background: #4b9a5e !important;
}
</style>
